export default "__VITE_ASSET__Dhgbv0A$__"